module.exports = __webpack_public_path__ + "img/new-tag.fc1b1e18.svg";